import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import projects from './projects.json'

const PrjDetails = () => {
    const navigate = useNavigate()
    const prjId = useParams()
    const prj = projects.projects.filter(project => project.id === parseInt(prjId.pid))[0]
    // const tools = prj.tools.map(x => Object.keys(x))
    const tools = []
    const mtools = () => {
        for (const p in prj.tools) {
            tools.push(<a href={prj.tools[p]} className="tools-links">{p}</a>)
        }
    }
    mtools()
    console.log(prj.technologies)


    return ( 
        <motion.div className="prj-title"
        initial={{opacity: 0}} 
        animate={{opacity: 1}} 
        exit={{opacity: 0}}
        transition={{duration:0.5}}
        >
            <div className="prj-header">
                <button onClick={() => navigate('/projects')} className="prj-back">Back</button>
                <h4 className="prj-title">{prj.title}</h4>
            </div>

            <div className="prj-box">
                <div className="img-cont">
                    <img className="" src={prj.image} alt="" width="100%"/>
                </div>

                <div className="prj-details">
                    <p className="info">{prj.body}</p>
                    <div className="tools-buttons">
                        {tools}
                        <a href={prj.link} className="tools-links">Visit</a>
                    </div>
                    <div className="tech">
                        {/* {prj.technologies.map((tech) => (
                            <span className="tech">{tech}</span>
                        ))} */}
                    </div>
                </div>
            </div>
        </motion.div>
     );
}
 
export default PrjDetails;